<template>
  <section class="programme-selection">
    <div class="programme-selection-body">
      <h3>Select Programme</h3>
      <k-dropdown placeholder="Select a programme"
        :options="sortedProgrammes"
        v-model="selectedProgrammeId"
      ></k-dropdown>
      <div class="flexible-panel meeting-card">
        <h4>{{ selectedProgramme?.name || 'No programme selected' }}</h4>
        <div v-if="selectedProgramme" class="programme-status-container">
          <p v-if="selectedProgramme?.learner_status" class="status">
            <i class="fa-duotone fa-user-circle" aria-hidden="true"></i> Status: <b>{{ selectedProgramme.learner_status }}</b>
            <k-external-data-label :label="selectedProgramme?.learner_status_source || 'KATE'"/>
          </p>
          <p v-if="selectedProgramme.is_frozen" class="frozen">
            <i class="fas fa-lock-keyhole" aria-hidden="true"></i> Learner's access to this programme is currently <b>frozen</b>.
          </p>
        </div>
      </div>
    </div>
    <div class="programme-selection-body">
      <h3>Module</h3>
      <div class="flexible-panel meeting-card">
        <h4>Meetings</h4>
        <p>Milestone Module</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.programme-status-container .status > b {
  margin-right: 8px;
}
</style>

<script>
import KDropdown from '@base-components/k-dropdown.vue';
import KExternalDataLabel from '@base-components/k-external-data-label.vue';
import { sortObjectArray } from '@utils/sort-by-object-property';

export default {
  components: {
    KDropdown,
    KExternalDataLabel,
  },

  props: {
    programmes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      selectedProgrammeId: undefined,
    };
  },

  watch: {
    sortedProgrammes: {
      handler(sortedProgrammes) {
        // Defer the assignment of the selectedProgrammeId to ensure the watcher on selectedProgrammeId is triggered
        this.$nextTick(() => {
          // If the are no programmes, set the selectedProgrammeId to null: null (new value) is different from
          // undefined (initial value defined when component is first created), which ensures the watcher is triggered
          // even in the case where selecting a user that has no available programmes
          this.selectedProgrammeId = sortedProgrammes[0]?.id || null;
        });
      },
      immediate: true,
    },

    selectedProgrammeId(id) {
      this.$emit('update:selected-programme-id', id);
    },
  },

  computed: {
    sortedProgrammes() {
      const sortedFrozenProgrammes = sortObjectArray(this.programmes.filter(p => p.is_frozen), 'start_date', true);
      const sortedUnfrozenProgrammes = sortObjectArray(this.programmes.filter(p => !p.is_frozen), 'start_date', true);
      return [...sortedUnfrozenProgrammes, ...sortedFrozenProgrammes];
    },

    selectedProgramme() {
      if (this.programmes.length === 0) {
        return undefined;
      }
      return this.programmes.find(programme => programme.id === this.selectedProgrammeId);
    },
  },
};
</script>
